import { Box, IconButton, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import LoopIcon from '@mui/icons-material/Loop';
import NamedTagChipList from "apps/web/src/views/Tags/NamedTagChipList";
import { TWTooltip } from "apps/web/src/componentLibrary/TWTooltip/TWTooltip";
import { AthletesByBulkAssignGoalTemplateJobForStatusModalFragment, useRetryBulkAssignGoalTemplateJobAthleteMutation } from "apps/web/src/types";
import { useTranslation } from "react-i18next";
import { useNutritionFlags } from "apps/web/src/hooks/useNutritionFlags";

const useStyles = makeStyles(() =>
  createStyles({
    chip: {
      cursor: "pointer",
    },
  })
);

interface JobStatusModalAthleteListItemProps {
  athlete: AthletesByBulkAssignGoalTemplateJobForStatusModalFragment;
  onClick?: (athlete: AthletesByBulkAssignGoalTemplateJobForStatusModalFragment) => void;
}

export const JobStatusModalAthleteListItem = ({
  athlete,
}: JobStatusModalAthleteListItemProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { succeededAt, failedAt, jobId } = athlete.bulkAssignGoalTemplateJobAthleteOffsetConnection.edges[0];
  const { isTeamScopedPermissionsEnabled } = useNutritionFlags();
  const parseStatusCopy = () => {
    if (succeededAt !== null) {
      return ["Assignment succeeded", `Succeeded on ${new Date(succeededAt).toLocaleString()}`, "success"];
    }
    if (failedAt !== null) {
      return [
        "Assignment failed",
        t("goalConfigurationTemplates.bulkAssign.status.modal.assignmentFailedMessage", { date: new Date(failedAt).toLocaleString() }),
        "failed",
      ];
    }
    return ["Assignment pending", "Check back again later", "pending"];
  };
  const [statusTitle, statusSubcopy, status] = parseStatusCopy();

  const [retryJobAthlete] = useRetryBulkAssignGoalTemplateJobAthleteMutation({});

  const handleRetryJobAthlete = async (athleteId: string) => {
    await retryJobAthlete({
    variables: {
      input: {
        jobId,
        athleteId,
      }
    }
  })};

  return (
    <Box sx={{ display: "flex", flex: 1, height: 38, my: 1, py: 1, px: 2, background: "#F8FAFB", alignItems: "center", pr: status === "failed" ? 1 : undefined }}>
      <Box sx={{ display: "flex", flex: 1 }}>
        <Typography sx={{ mr: 1 }}>{`${athlete.lastName}, ${athlete.firstName} `}</Typography>
        {!isTeamScopedPermissionsEnabled && (
          <NamedTagChipList
            namedTags={athlete.myNamedTagsOffsetConnection.edges}
            namedTagsCount={athlete.myNamedTagsOffsetConnection.pageInfo.total}
            chipClassName={classes.chip}
          />
        )}
      </Box>
      <Box>
        <TWTooltip title={statusTitle} subcopy={statusSubcopy}>
          {status === "success" ? (
            <CheckCircleIcon color="success" />
          ) : status === "failed" ? (
            <IconButton onClick={() => handleRetryJobAthlete(athlete.id)}><LoopIcon color="error" /></IconButton>
          ) : (
            <HistoryToggleOffIcon color="disabled" />
          )}
        </TWTooltip>
      </Box>
    </Box>
  );
};
